import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "./TitleDivSeo.css"
// import { useContext } from 'react';
// import { StatusContext } from '../ContextApiStatus';

function ImagesWithAlt(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>الخصائص البديلة للصور</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
        وجدنا في صفحة الويب الخاصة بك على عدد من الصور وهو {props.totalImages}
        </Typography>
        <Typography level="body-sm">
            يحتوي موقعك على عدد من الصور والتي تمتلك الخاصية {props.imagesWithAlt} alt 
        </Typography>
      </CardContent>
      { props.imagesAltAnalysis === "good" ? (
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} />
) : props.imagesAltAnalysis === "improve" ? (
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} />
) : <ClearIcon style={{ color: "red",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          يتم استخدام نص بديل لوصف الصور لإعطاء برامج زحف محرك البحث (وضعاف البصر).
أيضا ، مزيد من المعلومات لمساعدتهم على فهم الصور ، والتي يمكن أن تساعدهم في الظهور في نتائج بحث صور Google.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default ImagesWithAlt